/**
 * Facade for attio-common.ts functions
 * Provides backward compatibility while using the new modular services
 */
import { attioService } from './attio';

// Re-export functions from attio-common.ts using the new services
export const getValuationStatusOptions = () => attioService.status.getValuationStatusOptionsLegacy();

export const updateValuationStatus = (
  valuationId: string,
  statusOptionId: string,
  valuationDetail?: Record<string, unknown>,
  companyName?: string
) => attioService.status.updateValuationStatus({ valuationId, statusOptionId, valuationDetail, companyName });

export const updateValuationDealStage = (dealId: string, dealStageOptionId: string, companyName?: string) =>
  attioService.deals.updateValuationDealStage({ dealId, dealStageOptionId, companyName });

export const getAttioUserRecordId = (userEmail: string) => attioService.users.getUserRecordIdLegacy(userEmail);

export const getAnalystNote = (recordId: string) => attioService.notes.getAnalystNote(recordId);

export const getDealStatusOptions = () => attioService.deals.getDealStatuses();

export const sendFinalInvoice = (dealId: string, companyName?: string) =>
  attioService.deals.sendFinalInvoice(dealId, companyName);
